import { useNativePush } from "../helpers/useNativePush";
import styles from "./PushRegistrar.module.css";

/**
 * Invisible component designed to be dropped into the global context 
 * to silently activate background push notification logic within an active Auth context.
 */
export function PushRegistrar() {
  // Merely running the hook invokes the required initialization effects (e.g. Android channel setup + listener binding).
  useNativePush();

  // Rendering absolutely nothing.
  return null;
}